import { render } from "./BaseTable.vue?vue&type=template&id=71c8464d&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=71c8464d&lang=css"
import "./BaseTable.vue?vue&type=style&index=1&id=71c8464d&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c8464d"]])

export default __exports__